

























































































































import { Component, Prop, Ref, Vue, Watch } from 'vue-property-decorator'
import ClientConfig from '@/clients/entities/client-config'
import PushMessage from '@/clients/entities/push-message'

@Component
export default class SendPushDialog extends Vue {
  @Ref()
  private validator!: ValidationObserver

  private dialog = false
  private loading = false
  private confDialog = false

  private config = new ClientConfig()
  private message = new PushMessage()

  public open(config: ClientConfig) {
    this.config = config
    this.message = new PushMessage()
    this.dialog = true
    this.$nextTick(() => this.validator.reset())
  }

  private async send() {
    if (await this.validator.validate()) {
      if (this.config.isDebugHub) {
        this.dialog = false
        this.$emit('send', this.config, this.message)
      }
      else {
        this.confDialog = true
      }
    }
  }

  private async confSend(){
    this.confDialog = false
    this.dialog = false

    this.$emit('send', this.config, this.message)
  }

  private cancel() {
    this.dialog = false
    this.$emit('cancel')
  }
}
